const getContactLensSpecifications = (specs)=>{
    var ref, ref1, ref2, ref3, ref4;
    return [
        {
            name: 'baseCurve',
            value: specs === null || specs === void 0 ? void 0 : (ref = specs.baseCurve) === null || ref === void 0 ? void 0 : ref.toString()
        },
        {
            name: 'diameter',
            value: specs === null || specs === void 0 ? void 0 : (ref1 = specs.diameter) === null || ref1 === void 0 ? void 0 : ref1.toString()
        },
        {
            name: 'axis',
            value: specs === null || specs === void 0 ? void 0 : (ref2 = specs.axis) === null || ref2 === void 0 ? void 0 : ref2.toString()
        },
        {
            name: 'power',
            value: specs === null || specs === void 0 ? void 0 : (ref3 = specs.power) === null || ref3 === void 0 ? void 0 : ref3.toString()
        },
        {
            name: 'cylinder',
            value: specs === null || specs === void 0 ? void 0 : (ref4 = specs.cylinder) === null || ref4 === void 0 ? void 0 : ref4.toString()
        }, 
    ].filter((spec)=>Boolean(spec.value)
    );
};

export { getContactLensSpecifications };
//# sourceMappingURL=get-contact-lens-specifications.js.map
